import {useEffect} from "react"
import usePermissions from "../hooks/usePermissions"
import useModal from "../hooks/useModal";
import Section from "../components/Section"
import SectionHeader from "../components/SectionHeader"
import SectionContent from "../components/SectionContent"
import List from "../components/List"

export default function Users(){

    const {restrictSection}=usePermissions()
    useEffect(()=>{
        restrictSection("master","")
    },[])
    
    const {changeModal}=useModal()

    const edit=()=>{
        changeModal("user-edit","",0)
    }

    return(
        <Section>
            <SectionHeader
                title="Usuarios"
                intro="Personas que usan o administran Cajero24."
                back=""
                button={{label:"Nuevo usuario",icon:"create",link:"",href:"",clickEvent:edit}}
                tabs={[
                    {label:"Todos los usuarios",to:"/c24/usuarios"}
                ]}
            />
            <SectionContent>
                <List config={{
                    section:"users",
                    endpoint:"users/list",
                    limit:100,
                    counter:{
                        singular:"usuario",
                        plural:"usuarios"
                    },
                    action:{
                        mode:"modal",
                        context:"user",
                        reference:"user-info"
                    }
                }} />
            </SectionContent>
        </Section>
    )
    
}